module.exports = __webpack_public_path__ + "images/tycoon-10a90320c0b2aacd4e22324d4d4d3a42.png";